import _ from 'underscore';

function keyIsEnabled(event = {}) {
    const key = event.which || event.keyCode;
    if ((key > 47 && key < 58) ||
        _.contains([46, 8, 9, 27, 13], key) ||
        event.ctrlKey || (key >= 35 && key <= 39) ||
        (event.shiftKey && key === 45)) {
        return true;
    }
    if ((event.shiftKey && (key < 48 || key > 57)) ||
        (key < 96 || key > 105) ||
        (event.altKey && key > 95 && key < 106)) {
        event.preventDefault();
        return false;
    }
    return true;
}

function inputHandler(context) {
    return (event) => {
        const target = event.target;
        const value = target.value.replace(/[^\d]+/gi, '');
        if (value !== target.value) {
            target.value = value;
        }
    }
}

function keyDownHandler(context) {
    return (event) => {
        if (keyIsEnabled(event)) {
            if (_.isFunction(context.onKeyDown)) {
                return context.onKeyDown(event);
            }
            return true;
        }
        return false;
    }
}

function keyUpHandler(context) {
    return (event) => {
        if (keyIsEnabled(event)) {
            if (_.isFunction(context.onKeyUp)) {
                return context.onKeyUp(event);
            }
            return true;
        }
        return false;
    }
}

function initInputNumberCheck($el, context={}) {
    const removeListeners = [];
    if (context.onInput) {
        const handler = inputHandler(context);
        $el.on('input', handler);
        removeListeners.push(() => $el.off('input', handler));
    }
    if (context.onKeyDown) {
        const handler = keyDownHandler(context);
        $el.on('keydown', handler);
        removeListeners.push(() => $el.off('keydown', handler));
    }
    if (context.onKeyUp) {
        const handler = keyUpHandler(context);
        $el.on('keyup', handler);
        removeListeners.push(() => $el.off('keyup', handler));
    }
    return () => removeListeners.map((remove) => remove());
}

export default initInputNumberCheck;
export { keyIsEnabled };



// WEBPACK FOOTER //
// ./~/wgnet-awesomejs/lib/number_input_check.js